import { render, staticRenderFns } from "./childrenages.vue?vue&type=template&id=2217e7fd&"
import script from "./childrenages.vue?vue&type=script&lang=js&"
export * from "./childrenages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2217e7fd')) {
      api.createRecord('2217e7fd', component.options)
    } else {
      api.reload('2217e7fd', component.options)
    }
    module.hot.accept("./childrenages.vue?vue&type=template&id=2217e7fd&", function () {
      api.rerender('2217e7fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UNeZ49iqPoqd/JS/childrenages.vue"
export default component.exports